import styled from "styled-components";

const Container = styled.div``;
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: min(4.69vw, 67px) min(9.45vw, 135px);
  align-items: center;
  background-color: #ffffff;
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
  align-items: center;
  flex-direction: column;
  .blue-text {
    line-height: min(5.53vw, 79px);
    color: #095587;
    margin-bottom: 10px;
  }
  h4 {
    font-size: min(4.2vw, 60px);
    line-height: min(4.2vw, 60px);

    color: #000;
    letter-spacing: -0.66px;
    font-family: "robotoblack";
    margin-bottom: min(3.26vw,30px);
    text-align: center;
    max-width: min(77vw, 1108px);
  }
  h5 {
    font-size: min(1.4vw, 20px);
    line-height: min(1.82vw, 26px);
    letter-spacing: -0.66px;
    font-family: "robotobold";
    margin-bottom: min(5.26vw,45px);
    color: #095587;
    text-align: center;
    max-width: min(1036px,72vw);
  }
  img {
    width:min(7.07vw, 101px);
    max-width: 100%;
  }
  button {
        width: min(11.13vw,159px);
    height: min(2.73vw,39px);
    font-size: min(1.19vw,17px);
    border-radius: min(0.42vw,6px);
    background-color: #095587;
    font-family: "robotoregular";
    color: #fff;
    margin: min(3.99vw,57px) auto 0;
    border: none;
  }
  @media (max-width: 767px) {
    h4 {
    line-height: 4vw;
    margin-bottom: 2.42vw;
    }
    h5 {
    font-size: 2.84vw;
    line-height: 3.5vw;
    margin-bottom: 2.42vw;
    max-width: 100%;
}
button {
    width: 31.7vw;
    height: 7.74vw;
    font-size: 3.38vw;
    border-radius: 6px;
}
  }
  
`;
const ToolsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: min(6.02vw, 86px);
  margin-top: min(3.99vw, 57px);
`;
const ToolBox = styled.div`
  max-width: min(24.29vw,347px);
  text-align: center;
  .imgWrapper{
    min-height: 130px;
  }
  h6 {
    font-size: min(1.4vw, 20px);
    line-height: min(1.47vw, 21px);
    color: #095587;
    text-align: center;
    font-family: "robotobold";
    margin: min(3.01vw, 43px) 0 min(1.47vw, 21px);
  }
  p {
    font-size: min(1.19vw, 17px);
    font-weight: min(1.61vw, 23px);
    color: #095587;
    text-align: center;
    font-family: "robotoregular";
    /* display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis; */
    margin: 0;
  }
  @media (max-width: 1250px) {
    .imgWrapper{
      min-height: 115px;
    }
  }
  @media (max-width: 1024px) {
    .imgWrapper{
      min-height: 90px;
    }
  }
  @media (max-width: 767px) {
    width: 25vw;
    max-width: 100%;
    .imgWrapper{
      min-height: 70px;
    }
    h6 {
    font-size: 2.94vw;
    line-height: 3.14vw;
    margin-bottom: 2.42vw;
    }
    p {
        font-size: 2vw;
        line-height: 2.9vw;
        margin-bottom: 2.42vw;
    } 
  }  
  @media (max-width: 500px) {
    .imgWrapper{
      min-height: 50px;
    }
  }
  @media (max-width: 375px) {
    .imgWrapper{
      min-height: 30px;
    }
  }
`;

export { Container, Wrapper, ToolsWrapper, ToolBox };
